module.exports = __webpack_public_path__ + "assets/images/shop6.3000e64d.png";